import React from 'react';

export default () => (
    <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Close-Drawer" transform="translate(1.000000, 1.000000)" fill="#939597" fillRule="nonzero">
            <polygon id="Line-2" points="14.5228854 -0.707106781 15.937099 0.707106781 9.029 7.615 15.6198075 14.2055939 14.2055939 15.6198075 7.615 9.029 0.707106781 15.937099 -0.707106781 14.5228854 6.201 7.614 -0.389815277 1.02439829 1.02439829 -0.389815277 7.614 6.201"></polygon>
        </g>
    </svg>
)